import component from './component';
// import patchSlickCarousel from './patch-slick-carousel';
import breakpoints from './breakpoints';
import emitter from './emitter';
import modules from './modules';
import functions from './functions';
import feature from './feature';
// import tabStorage from './tab-storage';
import transitionEnd from './transition-end';

export default {
  component,
  emitter,
  // tabStorage,
  feature,
  transitionEnd,
  // patchSlickCarousel,
  ...breakpoints,
  ...functions,
  ...modules
};
